module.exports = __webpack_public_path__ + "media/images/career_camp/2022/home_steps_stars-4638141ff324f811b1a22d186ea3fecf.svg";